import { FC, RefObject } from 'react'
import { HotspotTeaser } from '@components/HotspotsSlider/HotspotTeaser/HotspotTeaser'
import ResponsiveImage from '@components/ResponsiveImage'
import { cls } from '@utils/classnames'

import { HostpotsSliderImage } from './HotspotsTypes'

interface HotspotsSlideProperties {
  slideIndex: number
  image: HostpotsSliderImage
  isActiveSlide: boolean
  onHotspotClick: (hotspotId: string, hotspotTitle: string) => void
  onHotspotClose: () => void
  activeHotspot: string | null
  ariaLabelCloseButton?: string
  sliderRef: RefObject<HTMLDivElement>
}

export const HostpotsSlide: FC<HotspotsSlideProperties> = ({
  slideIndex,
  image,
  isActiveSlide,
  onHotspotClick,
  onHotspotClose,
  activeHotspot,
  ariaLabelCloseButton,
  sliderRef,
}) => {
  return (
    <div className="cmp-hotspots-slide" role="group" aria-roledescription="slide" aria-label={image.trackingName}>
      <ResponsiveImage
        src={image.image.originalImageUrl}
        alt={image.image.altText || image.trackingName || ''}
        className="cmp-hotspots-slide__image"
      />
      {image?.hotspots?.map((hotspot, index) => {
        const hotspotId = `${slideIndex}-${index}-${hotspot.title}-${hotspot.positionHorizontal}-${hotspot.positionVertical}`
        return (
          <div
            key={index}
            style={{
              top: `${hotspot?.positionVertical}%`,
              left: `${hotspot?.positionHorizontal}%`,
            }}
            className={cls({
              'cmp-hotspots-slide__hotspot-container': true,
              'cmp-hotspots-slide__hotspot-container--is-active': activeHotspot === hotspotId,
            })}
          >
            <button
              className="cmp-hotspots-slide__hotspot"
              onClick={() => onHotspotClick(hotspotId, hotspot.title)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault()
                  event.stopPropagation()
                  onHotspotClick(hotspotId, hotspot.title)
                }
              }}
              aria-label={hotspot?.title}
              aria-expanded={activeHotspot === hotspotId}
              tabIndex={isActiveSlide ? 0 : -1}
            >
              <span className="cmp-hotspots-slide__hotspot-dot"></span>
            </button>

            <HotspotTeaser
              hotspot={hotspot}
              isVisible={activeHotspot === hotspotId}
              onCloseClick={onHotspotClose}
              ariaLabelCloseButton={ariaLabelCloseButton}
              sliderRef={sliderRef}
            />
          </div>
        )
      })}
    </div>
  )
}
